import { adminInstance } from '../axiosInstance';

const cleanFilters = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => String(value || '').trim())
  );

export const searchOrderTracking = (filters) =>
  adminInstance.get('ordertracking', { params: cleanFilters(filters) });

export const getOrderTracking = (id) =>
  adminInstance.get(`ordertracking/${id}`);

export const createOrderTracking = (payload) =>
  adminInstance.post('ordertracking', payload);

export const updateOrderTracking = (id, payload) =>
  adminInstance.put(`ordertracking/${id}`, payload);

export const addTrackingDetail = (orderId, payload) =>
  adminInstance.post(`ordertracking/${orderId}/details`, payload);

export const updateTrackingDetail = (orderId, detailId, payload) =>
  adminInstance.put(`ordertracking/${orderId}/details/${detailId}`, payload);
